// Blog Configuration
export const blogConfig = {
    postsPerPage: 6,
    showReadTime: true,
    enableComments: false,
    categories: ["devlog", "tutorial", "personal", "tech", "projects"],
    defaultThumbnail: "/images/blog/default.png",
    author: {
        name: "LumiYi",
        avatar: "/images/avatar.png",
    },
};

const blogPosts = [
    {
        id: "hello-world",
        title: "你好，世界！：我的第一篇博文",
        description: "欢迎来到我的开发日志！在这里，我将分享我的 Web 开发探索之旅。",
        date: "2026-01-18",
        tags: ["general", "intro"],
        filename: "hello-world.md",
        thumbnail: "/images/blog/",
        readTime: "2 min",
        author: "LumiYi",
        featured: true,
        category: "personal",
    },
    {
        id: "project-lumiyi",
        title: "构建 LumiYi：技术栈详解",
        description: "深入探讨构建此个人作品集网站所使用的现代 Web 技术。",
        date: "2026-01-18",
        tags: ["react", "frontend", "devlog"],
        filename: "project-lumiyi.md",
        thumbnail: "/images/blog/",
        readTime: "5 min",
        author: "LumiYi",
        featured: true,
        category: "devlog",
    },
    {
        id: "discord-bot-journey",
        title: "我的 Discord 机器人之旅",
        description: "从 JavaScript 到 TypeScript —— 构建功能丰富的 Discord 机器人。",
        date: "2026-01-17",
        tags: ["discord", "typescript", "nodejs"],
        filename: "discord-bot-journey.md",
        thumbnail: "/images/blog/",
        readTime: "8 min",
        author: "LumiYi",
        featured: true,
        category: "projects",
    },
    {
        id: "spotify-integration",
        title: "将 Spotify 集成到我的作品集中",
        description: "我是如何构建自定义 Spotify 可视化器和音乐播放器的。",
        date: "2026-01-16",
        tags: ["spotify", "api", "frontend"],
        filename: "spotify-integration.md",
        thumbnail: "/images/blog/",
        readTime: "6 min",
        author: "LumiYi",
        featured: false,
        category: "devlog",
    },
    {
        id: "react-hooks-tips",
        title: "React Hooks 使用技巧",
        description: "每一位开发者都应该掌握的 React Hooks 核心模式与最佳实践。",
        date: "2026-01-15",
        tags: ["react", "hooks", "tutorial"],
        filename: "react-hooks-tips.md",
        thumbnail: "/images/blog/",
        readTime: "7 min",
        author: "LumiYi",
        featured: false,
        category: "tutorial",
    },
    {
        id: "seo-best-practices",
        title: "个人网站 SEO 最佳实践",
        description: "针对搜索引擎优化个人作品集网站的全面指南。",
        date: "2026-01-14",
        tags: ["seo", "web", "marketing"],
        filename: "seo-best-practices.md",
        thumbnail: "/images/blog/",
        readTime: "10 min",
        author: "LumiYi",
        featured: false,
        category: "tutorial",
    },
];

export default blogPosts;
